export enum CUSTOM_EVENT_CONTENT_TYPES {
  CUSTOM_PAGEVIEW = 'customPageView',
}
